import { Box, MenuItem, Typography, Select } from '@mui/material';

const CustomComboBox = ({ label, onChange, items, value, prefix = '', prefixIndex = 0 }) => {
    return (
        <Box className="flex flex-col w-full  mt-5">
            <Typography
                variant={'body14'}
                className="text-gray-500 mb-1"
            >
                {label}
            </Typography>
            <Select
                value={value}
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                variant={'outlined'}
                className="text-gray-500 h-18"
            >
                {items.map((item, ind) => (
                    <MenuItem key={ind} value={item.value}>
                        {item.name + (prefixIndex <= ind ? prefix : '')}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};

export default CustomComboBox;
